import { render, staticRenderFns } from "./InterviewersDashboard.vue?vue&type=template&id=bfae08e6&"
import script from "./InterviewersDashboard.vue?vue&type=script&lang=js&"
export * from "./InterviewersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InterviewersDashboard.vue?vue&type=style&index=0&id=bfae08e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports